import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Stack } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useGetCustomerQuery } from 'services/customers'
import CustomerAutocomplete from 'components/generic/form/AsyncAutocomplete/CustomerAutocomplete'
import DialogModal from '.'

const AddCustomerModal = ({ open, onSave, priceLists, ...restProps }) => {
  const [selectedCustomerId, setSelectedCustomerId] = useState(null)
  const {
    control,
    formState: { errors },
    setError,
    clearErrors,
    reset,
  } = useForm()

  const { data: customerData } = useGetCustomerQuery(
    { customerId: selectedCustomerId },
    { refetchOnMountOrArgChange: true, skip: !selectedCustomerId },
  )

  useEffect(() => {
    if (open === true) {
      reset()
      setSelectedCustomerId('')
    }
  }, [open])

  return (
    <DialogModal
      open={open}
      {...restProps}
      onSave={() => {
        if (customerData.priceSheetId) {
          setError('customer', { type: 'custom', message: 'This customer already belongs to another price list.' })
        } else {
          onSave(customerData)
        }
      }}
      saveDisabled={!selectedCustomerId}
    >
      <Stack pt={1}>
        <CustomerAutocomplete
          name="customer"
          label="Customers"
          data-test="customer"
          variant="outlined"
          control={control}
          error={!!errors?.customer}
          helperText={errors?.customer?.message}
          freeSolo={false}
          onChange={customer => {
            clearErrors()
            if (customer) {
              setSelectedCustomerId(customer.id)
            } else {
              setSelectedCustomerId('')
            }
          }}
          autocompleteProps={{
            renderOption: (props, option) => (
              <li {...props} key={option.id}>
                {option.displayName}
              </li>
            ),
          }}
        />
      </Stack>
    </DialogModal>
  )
}

AddCustomerModal.propTypes = {
  ...DialogModal.propTypes,
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func,
  priceLists: PropTypes.array,
}

AddCustomerModal.defaultProps = {
  ...DialogModal.defaultProps,
  onSave: () => {},
  priceLists: [],
}

export default AddCustomerModal
